import { UI } from "../lib/constants/actions";
export const uiReducer = (state = {}, action) => {
    switch (action.type) {
        case UI.MESSAGE:
            return { ...state, uiMessage: action.payload }
        case UI.SHOW_LOADING:
            return { ...state, isLoading: action.payload }
        case UI.SHOW_MAIN_LOADING:
            return { ...state, isMainLoading: action.payload }
        case UI.SHOW_GOOGLE_LOADING:
            return { ...state, googleLoading: action.payload }
        case UI.SHOW_GOOGLE_GRAPH_LOADING:
            return { ...state, googleGraphLoading: action.payload }
        case UI.SELECT_GROUP_ID:
            return { ...state, selectedGroupId: action.payload }
        case UI.SHOW_TOP_SEARCHES_LOADING:
            return { ...state, topSearchesLoading: action.payload }
        case UI.PROFILE_LOADING:
            return { ...state, profileLoading: action.payload }
        case UI.FAILED_URLS_LOADING:
            return { ...state, failedUrlsLoading: action.payload }
        case UI.GOOGLE_ACTIVE_GRAPH:
            return { ...state, activeGraph: action.payload }
        case UI.PAGE_LOADING:
            return { ...state, [`PAGE-LOADING`]: action.payload }
        case UI.DASHBOARD_ACTIVE_TAB:
            return { ...state, activeTab: action.payload }
        case UI.EXPANDED_ROW:
            return { ...state, expandedRow: action.payload }
        case UI.CAMPAIGN_FILTERS:
            return { ...state, campaignFilters: action.payload }

        default:
            return state;
    }
};




